export default class Identity {
  /**
   * Create new identity and set properties based on the given object.
   *
   * @param {Object} obj
   */
  constructor (obj) {
    Object.assign(this, obj)
  }

  /**
   * @return {Date}
   */
  get dateOfBirth () {
    return this._dateOfBirth
  }

  /**
   * @param {string} value
   */
  set dateOfBirth (value) {
    this._dateOfBirth = new Date(value)
  }
}
